import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

import TrackingUpdatesPaginator from './TrackingUpdatesPaginator';

export const shipmentStatusTranslation = {
  unknown: 'Unknown',
  pending: 'Pending shipment',
  shipped: 'Shipped',
  delivered: 'Delivered',
  failed: 'Failed',
  processing: 'Processing',
};

export default types
  .model('Shipment', {
    isLoading: false,
    error: types.maybeNull(types.string),

    id: types.number,
    updated_at: types.maybe(types.string),
    shipper: types.maybe(types.string),
    rate: types.maybe(types.number),
    from_summary: types.maybe(types.string),
    from_email: types.maybeNull(types.string),
    from_name: types.maybeNull(types.string),
    from_address: types.maybe(types.string),
    to_email: types.maybeNull(types.string),
    to_name: types.maybeNull(types.string),
    to_address: types.maybe(types.string),
    to_summary: types.maybe(types.string),
    status: types.maybe(types.string),
    tracking_url: types.maybe(types.string),
    tracking_number: types.maybe(types.string),
    order_item: types.maybe(types.string),
    order_uid: types.maybe(types.string),
    direction: types.maybe(types.string),
    seconds_until_expiration: types.maybe(types.number),
    expiration_time: types.maybe(types.string),

    tracking_updates: types.optional(TrackingUpdatesPaginator, {}),
  })
  .views(self => ({
    get human_status() {
      return shipmentStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
    get human_direction() {
      return { deliver: 'Delivery', return: 'Return' }[self.direction];
    },
  }))
  .actions(self => ({
    afterCreate() {
      self.tracking_updates.id = self.id;
      self.tracking_updates.load();
    },
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-shipment-data', null, { id: self.id });
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
